import { render, staticRenderFns } from "./add-new.vue?vue&type=template&id=2728d852&scoped=true&"
import script from "./add-new.vue?vue&type=script&lang=js&"
export * from "./add-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2728d852",
  null
  
)

export default component.exports